<div class="alert">
  <div class="alert-content">
    <div class="loader-container">
      <div class="loader"></div>
    </div>
    <p [innerHTML]="message"></p>
  </div>
</div>